import { Alert, Box, Button, Dialog, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";
import { useState } from "react";
import { radius } from "../../../../theme";

export default function UploadB3() {
  const [help, setHelp] = useState<string | undefined>();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      gap={1}
      py={2}
      width="100%"
    >
      <Alert
        color="info"
        variant="outlined"
        icon={false}
        sx={{ borderRadius: `${radius.md}px`, alignItems: "center" }}
        action={
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              setHelp(
                "https://scribehow.com/embed/Como_baixar_o_Extrato_de_Negociacao_da_B3__i1bTmqa7QuuD9uL0kU9Ryw"
              )
            }
          >
            Baixar
          </Button>
        }
      >
        1. Cadastre as Operações importando o Extrato de Negociação
      </Alert>
      <Alert
        color="info"
        variant="outlined"
        icon={false}
        sx={{ borderRadius: `${radius.md}px`, alignItems: "center" }}
        action={
          <Button
            variant="contained"
            color="primary"
            onClick={() =>
              setHelp(
                "https://scribehow.com/embed/Como_baixar_o_Extrato_de_Movimentacao_da_B3__RIN0C3-6Q_uBkxOCATa3dQ"
              )
            }
          >
            Baixar
          </Button>
        }
      >
        2. Cadastre as{" "}
        <MuiLink
          component={Link}
          to="#subscricoes"
          sx={(theme) => ({
            color: theme.palette.accentInk,
            textDecorationColor: theme.palette.accentInk,
          })}
        >
          Subscrições
        </MuiLink>{" "}
        importando o Extrato de Movimentação
      </Alert>
      <Dialog
        open={!!help}
        onClose={() => setHelp(undefined)}
        maxWidth="md"
        fullWidth
      >
        <Box
          component="iframe"
          src={help}
          allowFullScreen
          sx={{ display: "block", width: "100%", height: 640, border: 0 }}
        />
      </Dialog>
    </Box>
  );
}
